<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import Ad from "./UI.Ad.svelte";
  import Audience from "./UI.Audience.svelte";
  import Audio from "./UI.Audio.svelte";
  import Progress from "./UI.Progress.svelte";
  import Popup from "./UI.Popup.svelte";
  import Legal from "./UI.Legal.svelte";
  import End from "./UI.End.svelte";
  import Mute from "./UI.Mute.svelte";
  import Guide from "./UI.Guide.svelte";
  import About from "./UI.About.svelte";
  import {
    mode,
    progress,
    selectedAudience,
    showPopup,
    adOpen,
    audienceOpen,
    abouted,
  } from "../stores/global.js";
  import sxm from "../svg/sxm.svg";

  export let delay = 0;
  let begun = false;
  let guide;

  const onDeck = {
    show: false,
    scroll: false,
    audience: false,
  };

  const done = {
    show: false,
    scroll: false,
    audience: false,
  };

  const pause = (dur) => {
    return new Promise((resolve) => {
      setTimeout(resolve, dur);
    });
  };

  $: if (begun && $showPopup) done.show = true;
  $: if (begun && $progress > 0) done.scroll = true;
  $: if (begun && $selectedAudience !== "All") done.audience = true;

  $: guideVisible = guide && !done[guide];
  $: if (!$showPopup) checkOnDeck();
  $: if ($showPopup || $adOpen || $audienceOpen) guide = null;
  $: if (guide === "show" && $progress > 0) guide = null;
  $: if ($abouted) guide = null;
  $: $mode === "explore", startGuide();

  const checkOnDeck = () => {
    const waiting = Object.keys(onDeck).filter((d) => onDeck[d]);
    if (waiting.length) activateGuide(waiting[0], 1000);
  };

  const activateGuide = async (name, dur) => {
    if (done[name]) return;
    if ($showPopup || $adOpen || $audienceOpen || $abouted) {
      onDeck[name] = true;
      return;
    }

    onDeck[name] = false;
    await pause(dur);
    guide = name;
    await pause(7000);
    guide = null;
    done[name] = true;
    checkOnDeck();
    return true;
  };

  const startGuide = async () => {
    await pause(delay + 250);
    begun = true;
    await activateGuide("show", 3000);
    await activateGuide("scroll", 5000);
    await activateGuide("audience", 5000);
  };
</script>

<section>
  {#if $mode === "explore"}
    <div id="ui" in:fade="{{ delay }}">
      <div class="logos">
        <a href="https://www.sxmmedia.com/" aria-label="SXM Media"
          >{@html sxm}</a
        >
      </div>
      <Ad />
      <Audience />
      <Audio />
      <Legal />
    </div>
  {/if}

  <Popup />
  {#if $mode === "explore"}
    <div in:fade>
      <Progress />
    </div>
  {/if}
  <End />
  {#if guideVisible}
    <Guide name="{guide}" />
  {/if}
</section>

<style>
  section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: var(--z-top);
    pointer-events: none;
    overflow: hidden;
    user-select: none;
  }

  section::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 11em;
    left: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0,
      var(--base-black) 70%
    );
  }

  .logos {
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
    pointer-events: auto;
    transform: scale(1.5);
    transform-origin: 0 0;
  }

  @media only screen and (max-width: 640px) {
    .logos {
      transform: scale(1);
    }
  }
</style>
